import { useMemo } from 'react';
import {
  GetAutoPilotSettingsQuery,
  useGetAutoPilotSettingsQuery
} from 'graphql/types';

export const useAutoPilotSettings = (): {
  data: GetAutoPilotSettingsQuery | undefined;
  loading: boolean;
} => {
  const { loading, data } = useGetAutoPilotSettingsQuery({
    fetchPolicy: 'cache-and-network'
  });

  return useMemo(
    () => ({
      loading,
      data
    }),
    [data, loading]
  );
};
